import React from 'react'
import { Link } from 'gatsby'
import shortid from 'shortid'

const Logo = ({ wordmark = false }) => {
  const uid = `logo-${shortid.generate()}`
  return (
    <Link to="/" className="no-line">
      {wordmark ? (
        <svg
          width="83"
          height="18"
          xmlns="http://www.w3.org/2000/svg"
          aria-labelledby={uid}
        >
          <title id={uid}>Versett</title>
          <path d="M81.282 15.553c-1.282 0-2.184-.32-2.184-2.883V6.582h3.436V4.456h-3.436V0h-2.534v4.456h-2.446v2.126h2.446v6.641c0 4.34 2.534 4.631 4.164 4.631.845 0 1.777-.087 2.272-.174v-2.243c-.379.058-1.194.116-1.718.116zM69.778 12.67V6.582h3.437V4.456h-3.437V0h-2.533v4.456h-2.447v2.126h2.447v6.641c0 4.34 2.533 4.631 4.164 4.631.845 0 1.777-.087 2.272-.174v-2.243c-.379.058-1.194.116-1.719.116-1.28 0-2.184-.32-2.184-2.883zm-8.824-2.854c0-2.301-1.602-3.758-3.728-3.758-2.271 0-3.873 1.37-3.931 3.758h7.659zm2.446.262c0 .378 0 .932-.116 1.66H53.266c.116 2.243 1.193 4.136 4.106 4.136 1.98 0 2.941-.961 3.349-2.097h2.563C62.847 16.019 60.692 18 57.372 18c-4.456 0-6.611-3.117-6.611-6.932 0-3.99 2.359-6.961 6.523-6.961 3.437 0 6.116 2.592 6.116 5.97zm-18.61.233c-2.446-.787-3.814-.99-3.814-2.33 0-1.195 1.048-1.835 2.446-1.835 1.747 0 2.68.873 2.68 2.417h2.446c0-2.65-2.214-4.456-5.097-4.456-2.737 0-4.922 1.34-4.922 3.815 0 2.389 1.573 3 3.582 3.641 2.65.903 4.223 1.049 4.223 2.534 0 1.31-1.048 1.893-2.65 1.893-1.776 0-3.116-.757-3.116-2.767h-2.475c0 3.204 2.562 4.777 5.475 4.777 2.97 0 5.183-1.31 5.183-3.961 0-2.505-1.95-3.088-3.96-3.728zM31.687 7.049V4.456h-2.534V17.68h2.534v-5.797c0-3.174 1.456-5.242 4.397-5.242.466 0 .728.029 1.252.145v-2.33c-.349-.145-.757-.204-1.252-.204-1.864 0-3.698 1.136-4.397 2.797zM24.2 9.816c0-2.301-1.602-3.758-3.728-3.758-2.271 0-3.873 1.37-3.931 3.758H24.2zm2.446.262c0 .378 0 .932-.116 1.66H16.513c.116 2.243 1.194 4.136 4.106 4.136 1.98 0 2.941-.961 3.349-2.097h2.563C26.094 16.019 23.939 18 20.619 18c-4.456 0-6.61-3.117-6.61-6.932 0-3.99 2.358-6.961 6.523-6.961 3.436 0 6.115 2.592 6.115 5.97zm-15.58-5.622h2.737L7.747 17.68H5.999L0 4.456h2.738l4.135 9.612 4.194-9.612z" />
        </svg>
      ) : (
        <svg
          viewBox="0 0 436 236"
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          role="presentation"
          aria-labelledby={uid}
        >
          <title id={uid}>Versett</title>
          <path d="M48.88.89l73.26 170.25L196.43.89h48.5L137.62 235.11h-31L.38.89h48.5zM297.54 1L190.47 235H233L340.11 1h-42.57zm95.51 0L286 235h42.56L435.62 1h-42.57z" />
        </svg>
      )}
    </Link>
  )
}

export default Logo
